import styled from 'styled-components';

interface InputProps {
    type?: string;
}

export const Container = styled.label<InputProps>`
    display: block;
    min-height: 88px;
    position: relative;

    .title {
        display: block;
        font-size: 14px;
        font-weight: 500;
        width: 100%;
        color: ${({ theme }) => theme.colors.interfaceText400};
        
        span {
            color: ${({ theme }) => theme.colors.primaryRed400};
            margin-left: 4px;
        }
    }

    input {
        width: 100%;
        height: 32px;
        background: ${(props: any) => props.theme.colors.white};
        border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
        border-radius: 6px;
        outline: none;
        padding: 6px 12px;
        margin-top: 8px;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        color: ${(props: any) => props.theme.colors.interfaceText500};
        transition: border-color 0.2s;
        
        &:hover {
            border: 1px solid ${(props: any) => props.theme.colors.c000000};
        }
        
        &:focus {
            border: 1px solid ${(props: any) => props.theme.colors.c000000};
            outline: none;
        }
    }
    &.empty {
        input {
            border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            }
        }
    }
    &.error {
        input {
            border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            }
        }
    }
    .error-message {
        display: block;
        margin-top: 4px;
        font-size: 0.75rem;
        color: ${({ theme }) => theme.colors?.interfaceDanger || '#E52940'};
        line-height: 1.2;
    }
`;